<template>
  <div>
    <el-card>
      <el-alert title="关于我们" type="info" center show-icon :closable='false'> </el-alert>
      <div class="aboutWe_container">
        <div class="aboutWe_text">
          <h3>编辑关于我们</h3>
        </div>
        <div class="aboutWe_img">
          <div>
            <div class="text">
              横幅图 ( 顶图 )
            </div>
            <div class="backgroundImgUploads">
              <div class="backgroundImgList">
                  <img :src="topImg" alt="">
              </div>
              <el-upload
                  action="string"
                  list-type="picture-card"
                  :http-request="updateTopImg"
                  accept=".png,.jpg,.jpeg"
                  :show-file-list="false">
                  <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="uploadTip">建议上传相同比例的横幅图</div>
          </div>
          <div>
            <div class="text">
              行业领域
            </div>
            <div class="backgroundImgUploads">
              <div class="backgroundImgList">
                <img :src="industryImg" alt="">
              </div>
              <el-upload
                action="string"
                list-type="picture-card"
                :http-request="updateIndustryImg"
                accept=".png,.jpg,.jpeg"
                :show-file-list="false">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
          <div>
            <div class="text">
              公司简介图 ( 首页 )
            </div>
            <div class="backgroundImgUploads">
              <div class="backgroundImgList backgroundImgList2">
                <img :src="companyIntroImg" alt="">
              </div>
              <el-upload
                action="string"
                list-type="picture-card"
                :http-request="updateCompanyIntroImg"
                accept=".png,.jpg,.jpeg"
                :show-file-list="false">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
        <div class="aboutWe_img">
          <div>
            <div class="text">
              公司介绍图1
            </div>
            <div class="backgroundImgUploads">
              <div class="backgroundImgList aboutWe_introImg1">
                  <img :src="industryImg2" alt="">
              </div>
              <el-upload
                  action="string"
                  list-type="picture-card"
                  :http-request="updateIndustryImg2"
                  accept=".png,.jpg,.jpeg"
                  :show-file-list="false">
                  <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="uploadTip">建议上传比例：3:4（宽:高）</div>
          </div>
          <div>
            <div class="text">
              公司介绍图2
            </div>
            <div class="backgroundImgUploads">
              <div class="backgroundImgList aboutWe_introImg2">
                <img :src="industryImg3" alt="">
              </div>
              <el-upload
                action="string"
                list-type="picture-card"
                :http-request="updateIndustryImg3"
                accept=".png,.jpg,.jpeg"
                :show-file-list="false">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
            <div class="uploadTip">建议上传比例：3:4（宽:高）</div>
          </div>
        </div>
        <div class="text">
          公司资质
          <el-upload
            action="string"
            list-type="picture-card"
            multiple
            :http-request="uploadCertification"
            accept=".png,.jpg,.jpeg"
            :show-file-list="false">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <div class="certification-box">
          <div class="certification-box-item" v-for="(item,index) in certificationImgList" :key="index">
            <img :src="item" alt="">
            <div class="elIconDelete" @click.stop="delCertification(item)"><i class="el-icon-delete"></i></div>
          </div>
        </div>
        <!-- 分页区域 -->
        <div class="pagination" v-if="certificationImgList.length">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="certificationInfo.pageNum"
            :page-sizes="[8, 16, 30, 50]"
            :page-size="certificationInfo.pageSize"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
        <el-form label-width="90px" label-position="top" class="aboutWe_form">
          <el-form-item label="数据统计" prop="valueData">
            <div class="valueDataList">
              <div class="valueDataItem" v-for="(item,index) in aboutWeForm.valueData" :key="index">
                <el-input v-model="item.name" placeholder="名称" class="valueDataInput"></el-input>
                <el-input v-model="item.value" placeholder="数值" class="valueDataInput"></el-input>
              </div>
            </div>
          </el-form-item>

          <el-tabs v-model="aboutEditorTab">
            <el-tab-pane label="公司介绍" name="content">
              <!-- 关于我们富文本 -->
              <el-form-item label="公司介绍:" prop="content">
                <!-- 关于我们内容 富文本组件-->
                <quill-editor-component type="aboutWe" uploadImgId="uploadImgId1" uploadVideoId="uploadVideoId1" ref="quillEditorRef"></quill-editor-component>
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="公司介绍(二)" name="contnet2">
              <el-form-item label="公司介绍(二):" prop="contnet2">
                <quill-editor-component type="aboutWe" uploadImgId="uploadImgId5" uploadVideoId="uploadVideoId5" ref="quillEditorRef2"></quill-editor-component>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>

          <el-form-item class="btns">
            <el-button type="primary" @click="addAboutWe" :loading="isAdd">编辑</el-button>
            <el-button @click="resetCustomerCaseForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import quillEditorComponent from '../../components/quillEditorComponent.vue'
import {
  updateTopImg, getTopImg, updateCompanyIntroImg, getCompanyIntroImg, updateIndustryImg, updateIndustryImg2, updateIndustryImg3, getIndustryImg, uploadCertification,
  getCertification, delCertification, addOrUpdate, getAdminAboutSettings
} from '@/api/editAboutWe'

// 默认数据
// const DEFAULT_VALUE_DATA = [
//   {name: '行业经验', value: '3000'},
//   {name: '合作客户', value: '1000'},
//   {name: '服务团队', value: '100'},
//   {name: '研发团队', value: '50'}
// ]
const DEFAULT_VALUE_DATA = [
  { name: '', value: '' },
  { name: '', value: '' },
  { name: '', value: '' },
  { name: '', value: '' }
]

export default {
  components: {
    quillEditorComponent
  },
  data () {
    return {
      topImg: '', // 顶部图片
      companyIntroImg: '', // 公司简介图
      industryImg: '', // 行业资质图片
      industryImg2: '', // 公司介绍图1
      industryImg3: '', // 公司介绍图2
      // 获取新闻资讯列表的参数对象
      certificationInfo: {
        pageNum: 1, // 当前的页数
        pageSize: 8 // 当前显示的多少条数据
      },
      // 总条数
      total: 0,
      certificationImgList: [], // 公司资质图片列表
      aboutEditorTab: 'content',
      aboutWeForm: {
        content: '', // 富文本内容
        contnet2: '', // 富文本内容2
        valueData: DEFAULT_VALUE_DATA.map(item => ({ ...item })) // 数据统计内容,
        // addFileIdList: [], //添加的图片或视频id
        // removeFileIdList: [],  //删除添加完又去去除的图片
      },
      // 添加按钮样式
      isAdd: false
    }
  },
  mounted () {
    this.getTopImg()
    this.getCompanyIntroImg()
    this.getIndustryImg()
    this.getCertification()
    this.getAboutWe()
  },
  methods: {
    // 添加或编辑关于我们顶部图片
    updateTopImg (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      updateTopImg(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getTopImg()
        }
      })
    },
    // 获取顶部图片
    getTopImg () {
      getTopImg().then(res => {
        if (res.code == 0) {
          this.topImg = res.data.value
        } else {
          this.$message.error('获取关于我们横幅图失败！')
        }
      })
    },
    // 添加或编辑公司简介图
    updateCompanyIntroImg (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      updateCompanyIntroImg(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getCompanyIntroImg()
        }
      })
    },
    // 获取公司简介图
    getCompanyIntroImg () {
      getCompanyIntroImg().then(res => {
        if (res.code == 0) {
          this.companyIntroImg = res.data.value
        } else {
          this.$message.error('获取公司简介图失败！')
        }
      })
    },
    // 添加行业领域图片
    updateIndustryImg (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      updateIndustryImg(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getIndustryImg()
        }
      })
    },
    // 添加公司介绍图1
    updateIndustryImg2 (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      updateIndustryImg2(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getIndustryImg()
        }
      })
    },
    // 添加公司介绍图2
    updateIndustryImg3 (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      updateIndustryImg3(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getIndustryImg()
        }
      })
    },
    // 获取图片
    getIndustryImg () {
      getIndustryImg().then(res => {
        if (res.code == 0) {
          this.industryImg = res.data.value
          this.industryImg2 = res.data.value2
          this.industryImg3 = res.data.value3
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 添加公司资质图片
    uploadCertification (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      uploadCertification(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.getCertification()
        }
      })
    },
    // 分页功能下拉选择器触发
    handleSizeChange (newSize) {
      this.certificationInfo.pageSize = newSize
      // 重新获取数据
      this.getCertification()
    },
    // 监听页码值改变
    handleCurrentChange (newSize) {
      this.certificationInfo.pageNum = newSize
      // 重新获取数据
      this.getCertification()
    },
    // 获取公司资质图片
    getCertification () {
      getCertification(this.certificationInfo).then(res => {
        if (res.code == 0) {
          this.certificationImgList = res.data.data
          this.total = res.data.total
        } else {
          this.$message.error('获取公司资质图失败！')
        }
      })
    },
    // 删除公司资质图片
    delCertification (url) {
      delCertification(url).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功！')
          // 重新获取数据
          this.getCertification()
        } else {
          this.$message.error('删除失败！')
        }
      })
    },
    // 重置
    resetCustomerCaseForm () {
      if (this.$refs.quillEditorRef) {
        this.$refs.quillEditorRef.content = ''
      }
      if (this.$refs.quillEditorRef2) {
        this.$refs.quillEditorRef2.content = ''
      }
      this.aboutWeForm.content = ''
      this.aboutWeForm.contnet2 = ''
      this.aboutWeForm.valueData = DEFAULT_VALUE_DATA.map(item => ({ ...item }))
    },
    // 获取关于我们的内容
    getAboutWe () {
      getAdminAboutSettings({
        keyname: 'ABOUTUS'
      }).then(res => {
        if (res.code == 0) {
          if (this.$refs.quillEditorRef) {
            this.$refs.quillEditorRef.content = res.data.value || ''
          }
          if (this.$refs.quillEditorRef2) {
            this.$refs.quillEditorRef2.content = res.data.value2 || ''
          }
          this.aboutWeForm.content = res.data.value || ''
          this.aboutWeForm.contnet2 = res.data.value2 || ''
          if (Array.isArray(res.data.valueData) && res.data.valueData.length) {
            this.aboutWeForm.valueData = res.data.valueData.map(item => ({
              name: item.name || '',
              value: item.value === undefined || item.value === null ? '' : String(item.value)
            }))
          } else {
            this.aboutWeForm.valueData = DEFAULT_VALUE_DATA.map(item => ({ ...item }))
          }
        } else {
          this.$message.error('获取关于我们相关内容失败！')
        }
      })
    },
    // 编辑关于我们内容
    addAboutWe () {
      this.isAdd = true
      this.aboutWeForm.content = this.$refs.quillEditorRef ? this.$refs.quillEditorRef.content : ''
      this.aboutWeForm.contnet2 = this.$refs.quillEditorRef2 ? this.$refs.quillEditorRef2.content : ''
      // const imagesList = this.$refs.quillEditorRef.imagesList
      // // 返回案例中存在和不存在的图片或视频数组
      // imagesList.filter(item =>{
      //   if(this.aboutWeForm.content.indexOf(item.url) != -1){
      //     this.aboutWeForm.addFileIdList.push(item.id)
      //   }else{
      //     this.aboutWeForm.removeFileIdList.push(item.id)
      //   }
      //   return
      // })
      if (this.aboutWeForm.content == '') {
        this.$message.error('请输入公司相关内容！')
        this.isAdd = false
        return
      }
      // if(this.aboutWeForm.contnet2 == ""){
      //   this.$message.error("请输入公司第二模块相关内容！")
      //   this.isAdd = false
      //   return
      // }
      // 编辑接口  接口问题直接提交内容
      addOrUpdate({
        value: this.aboutWeForm.content,
        value2: this.aboutWeForm.contnet2,
        valueData: this.aboutWeForm.valueData,
        keyname: 'ABOUTUS'
      }).then(res => {
        if (res.code == 0) {
          this.isAdd = false
          this.$message.success('编辑成功')
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.aboutWe_container{
  margin-top: 20px;
  .aboutWe_text{
    h3{
      width: 170px;
      border-bottom: 2px solid #409eff;
    }
  }
  .aboutWe_img{
    display: flex;
    overflow: auto;
  }
  .text{
    margin-top: 30px;
    margin-left: 20px;
    display: flex;
    /deep/ .el-upload--picture-card{
      width: 48px;
      height: 24px;
      margin-left: 18px;
      line-height: 24px;
      i{
        font-size: 15px;
      }
    }
  }
  .backgroundImgUploads{
    display: flex;
    margin: 20px;
    overflow-x: auto;
    .backgroundImgList{
      width: 258px;
      height: 148px;
      position: relative;
      margin-right: 2px;
      img{
        width: 258px;
        height: 148px;
        cursor: pointer;
      }
      .elIconDelete{
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 24px;
        cursor: pointer;
      }
    }
    .aboutWe_introImg1{
      width: 258px;
      height: 344px;
      img{
        width: 258px;
        height: 344px;
        object-fit: cover;
      }
    }
    .aboutWe_introImg2{
      width: 258px;
      height: 344px;
      img{
        width: 258px;
        height: 344px;
        object-fit: cover;
      }
    }
    .backgroundImgList2{
      width: 258px;
      height: 176px;
      img{
        width: 258px;
        height: 176px;
        object-fit: cover;
      }
    }
  }
  .certification-box{
    max-height: 400px;
    margin: 18px;
    overflow-y: auto;
    .certification-box-item{
      width: 120px;
      height: 150px;
      position: relative;
      margin-top: 5px;
      margin-left: 9px;
      float: left;
      img{
        width: 120px;
        height: 150px;
        cursor: pointer;
      }
      .elIconDelete{
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
  .pagination{
    text-align: center;
  }
  .aboutWe_form{
    margin-top: 20px;
    .valueDataList{
      .valueDataItem{
        display: flex;
        margin-bottom: 10px;
        .valueDataInput{
          width: 260px;
          margin-right: 10px;
        }
      }
    }
    .btns{
      display: flex;
      justify-content: flex-end;
    }
  }
}

.uploadTip{
  font-size: 12px;
  color: red;
  margin-top: -10px;
  margin-left: 20px;
}
</style>
